import React from "react";

type GooglePlayButtonProps = {
  className?: string;
};

const GooglePlayButton: React.FC<GooglePlayButtonProps> = ({ className = "" }) => (
  <a
    href="https://play.google.com/store/apps/details?id=com.ammopantry.ai.app"
    target="_blank"
    rel="noopener noreferrer"
    className={`inline-flex items-center gap-3 px-4 py-2 rounded-md border border-gray-300 shadow-sm hover:opacity-90 transition-opacity !bg-black ${className}`}
    style={{
      background: 'linear-gradient(to bottom, #1d1d1f 0%, #000000 100%) !important',
      minWidth: '155px',
    }}
  >
    {/* Google Play Logo */}
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="flex-shrink-0"
    >
      <path
        d="M3 20.5v-17c0-.59.34-1.11.84-1.35L13.69 12 3.84 21.85c-.5-.24-.84-.76-.84-1.35zm13.81-5.38L6.05 21.34l8.49-8.49 2.27 2.27zm-1.36-3.24L6.05 2.66l10.76 6.12-2.27 2.27zM6.05 21.34l10.76-6.22-2.27-2.27L6.05 21.34z"
        fill="white"
      />
    </svg>
    {/* Text */}
    <div className="flex flex-col leading-tight">
      <span className="text-[10px] text-white leading-[1.1]" style={{ fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' }}>Get it on</span>
      <span className="text-[14px] text-white font-semibold leading-[1.1]" style={{ fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif', letterSpacing: '-0.01em' }}>Google Play</span>
    </div>
  </a>
);

export default GooglePlayButton;

